export default __webpack_public_path__ + "static/media/tms-planck.ba0271c8.pdf";